import React from 'react'

const ViewClient = () => {
    return (
        <div>
            <div className="modal fade" id="viewClientModal" tabindex="-1" aria-labelledby="viewClientModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title font-bold" id="viewClientModalLabel">Client Information</h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">


                            <div className="card mb-3">
                                <div className="m-3">
                                    <h6 className='section-title'>Basic Details:</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Date</label>
                                            <p>2024-12-13</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label className="form-label">Sub Category</label>
                                            <p>2BHK</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Property For</label>
                                            <p>RENT</p>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Area</label>
                                            <p>1500 sq. ft</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <label className="form-label">Acceptable Broker</label>
                                            <p>XYZ Brokers</p>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Category</label>
                                            <p>Residential</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="card mb-3">
                                <div className="m-3">
                                    <h6 className='section-title'>Client Details:</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label className="form-label">Name</label>
                                            <p>John Doe</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Mobile No</label>
                                            <p>+1234567890</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Email ID</label>
                                            <p>johndoe@example.com</p>
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label className="form-label">Address</label>
                                            <p>123 Main St, City, Country</p>
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label className="form-label">Native</label>
                                            <p>Delhi</p>
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label className="form-label">Occupation</label>
                                            <p>Business</p>
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label className="form-label">Budget</label>
                                            <p>$500,000</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="card mb-3">
                                <div className="m-3">
                                    <h6 className='section-title'>Status:</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <label className="form-label">Status</label>
                                            <p>HOT</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Response</label>
                                            <p>INTERESTED</p>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Source</label>
                                            <p>NEW INQUIRY (STAGE 1)</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="card mb-3">
                                <div className="m-3">
                                    <h6 className='section-title'>Other:</h6>
                                </div>
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label">Remarks</label>
                                            <p>No additional remarks</p>
                                        </div>
                                        <div className="col-md-4 mt-3">
                                            <label className="form-label">Next Follow Up</label>
                                            <p>2024-12-20</p>
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label className="form-label">Assign To</label>
                                            <p>Agent A</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>




        </div>
    )
}

export default ViewClient
